import { useState } from "react";
import uuid from "react-uuid";
import { toast } from "react-toastify";

import { IoInfinite } from "react-icons/io5";
import { FiPlus } from "react-icons/fi";
import { RiArrowGoBackFill } from "react-icons/ri";
import { HiOutlineMinus } from "react-icons/hi2";

import { FormContainer } from "../../styled/setting";

import ActionButtons from "../../setting/common/actionButtons";
import InputField from "../common/form/inputField";
import Switch from "../common/form/switch";
import Tooltip from "../common/form/tooltip";

import { defaultOpt, toMenuTooltip, tooltips } from "../../function/store";

const OptionForm = ({ option, setOption }) => {
  const [context, setContext] = useState(null);

  const changeInput = (e) => {
    const { name, value } = e.target;
    setOption((prev) => ({ ...prev, [name]: value }));
  };

  const addOption = () => {
    setOption((prev) => ({
      ...prev,
      options: [...prev.options, { ...defaultOpt, id: uuid() }],
    }));
  };

  const toggleOptionType = (index) => {
    setOption((prev) => ({ ...prev, isRequired: index === 0 }));
  };

  const handleOptionChange = (id, field, value) => {
    setOption((prev) => ({
      ...prev,
      options: prev.options.map((opt) => (opt.id === id ? { ...opt, [field]: value } : opt)),
    }));
  };
  const removeOption = (id) => {
    if (!option?.options || option.options.length === 1) {
      toast.error("옵션 그룹에는 최소 1개의 옵션이 필요합니다.");
      return;
    }

    setOption((prev) => ({
      ...prev,
      options: prev.options.filter((opt) => opt.id !== id),
    }));
  };

  const handleFocus = (e, id) => {
    const { name } = e.target;
    setOption((prev) => ({
      ...prev,
      options: prev.options.map((opt) =>
        opt.id === id ? { ...opt, [name]: toNumber(opt[name]) } : opt,
      ),
    }));
  };

  const handleBlur = (e, id) => {
    const { name } = e.target;
    setOption((prev) => ({
      ...prev,
      options: prev.options.map((opt) =>
        opt.id === id ? { ...opt, [name]: opt[name] ? formatNumber(opt[name]) : "" } : opt,
      ),
    }));
  };

  const numericChange = (id, name, value) => {
    let inputValue = toNumber(value);

    setOption((prev) => ({
      ...prev,
      options: prev.options.map((opt) =>
        opt.id === id
          ? {
              ...opt,
              [name]: inputValue === "" ? "" : /^\d+$/.test(inputValue) ? inputValue : opt[name],
            }
          : opt,
      ),
    }));
  };

  const toggleUnlimited = (id) => {
    setOption((prev) => ({
      ...prev,
      options: prev.options.map((opt) =>
        opt.id === id ? { ...opt, quantity: opt.quantity === -1 ? "" : -1 } : opt,
      ),
    }));
  };

  const changeStatus = (newStatus, item) => {
    setOption((prev) => ({
      ...prev,
      options: prev.options.map((opt) =>
        opt.id === item.id ? { ...opt, status: newStatus } : opt,
      ),
    }));
    setContext(null);
  };

  return (
    <div className="contents">
      <FormContainer>
        <InputField
          label="옵션그룹명"
          name="name"
          placeholder="옵션그룹명을 입력해주세요. 예) 사리 추가"
          value={option.name}
          onChange={changeInput}
        />
        <InputField
          label="관리옵션그룹명"
          name="codeName"
          placeholder="옵션그룹명을 입력해주세요. 예) 옵션1"
          value={option.codeName}
          onChange={changeInput}
          tooltip={tooltips.codeName}
        />
        <Switch
          label="옵션유형"
          keyName="required"
          options={tooltips.types.map((t, i) => ({ value: i === 0, label: t.title }))}
          value={option.isRequired}
          onChange={(val) => toggleOptionType(val ? 0 : 1)}
          tooltip={tooltips.types}
        />
        <li className="options">
          <Tooltip label="옵션내용" tooltip={toMenuTooltip()} />
          <div className="cont">
            <ul>
              <li className="header">
                <span>옵션상태</span>
                <span>옵션명</span>
                <span>옵션가격</span>
                <span>옵션수량</span>
                <span>옵션재고</span>
              </li>
              {option.options.map((opt, index) => (
                <li key={`opt-${opt.id || index}`}>
                  <ActionButtons
                    context={context}
                    setContext={setContext}
                    item={opt}
                    isContext={false}
                    changeStatus={changeStatus}
                    buttons={[
                      {
                        label: "삭제",
                        onClick: () => removeOption(opt.id),
                        icon: HiOutlineMinus,
                      },
                    ]}
                  />
                  <InputField
                    as="div"
                    name="value"
                    placeholder="옵션명을 입력해주세요. 예) 라면 사리"
                    value={opt.value}
                    onChange={(e) => handleOptionChange(opt.id, "value", e.target.value)}
                    max={30}
                  />
                  <InputField
                    as="div"
                    name="addPrice"
                    type="number"
                    placeholder="옵션 가격을 입력해주세요."
                    value={opt.addPrice === 0 ? "0" : opt.addPrice || ""}
                    onChange={(e) => numericChange(opt.id, "addPrice", e.target.value)}
                    keyboardEvent={{
                      onFocus: (e) => handleFocus(e, opt.id),
                      onBlur: (e) => handleBlur(e, opt.id),
                    }}
                    max={7}
                  />
                  <InputField
                    as="div"
                    name="consumeCount"
                    type="number"
                    placeholder="옵션 수량을 입력해주세요."
                    value={opt.consumeCount === 1 ? "1" : opt.consumeCount || ""}
                    onChange={(e) => numericChange(opt.id, "consumeCount", e.target.value)}
                    keyboardEvent={{
                      onFocus: (e) => handleFocus(e, opt.id),
                      onBlur: (e) => handleBlur(e, opt.id),
                    }}
                    max={7}
                  />
                  <InputField
                    as="div"
                    name="quantity"
                    type="number"
                    placeholder="옵션 재고를 입력해주세요"
                    value={opt.quantity}
                    onChange={(e) => numericChange(opt.id, "quantity", e.target.value)}
                    keyboardEvent={{
                      onFocus: (e) => handleFocus(e, opt.id),
                      onBlur: (e) => handleBlur(e, opt.id),
                    }}
                    children={
                      <button onClick={() => toggleUnlimited(opt.id)}>
                        {String(opt.quantity) === "-1" ? <RiArrowGoBackFill /> : <IoInfinite />}
                      </button>
                    }
                    max={4}
                  />
                </li>
              ))}
            </ul>
            <button className="add" onClick={addOption}>
              <FiPlus />
              <span>옵션 추가</span>
            </button>
          </div>
        </li>
      </FormContainer>
    </div>
  );
};

export default OptionForm;
